import axios from "axios";

const headers = {
  "Content-Type": "application/json;charset=utf-8"
};

const service = axios.create({
  headers,
  timeout: 150000,
  //baseURL: process.env.VUE_APP_API
});

service.interceptors.request.use(
  config => {
    // // 不传递默认不开启loading
    // if (config.showloading && process.env.VUE_ENV === "client") {
    //   // loading
    //   console.log("客户端");
    // } else {
    //   console.log("服务端");
    // }
    return config;
  },
  error => {
    console.log(error); // for debug
    return Promise.reject(error);
  }
);
// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.status && res.status !== 200) {
      // 登录超时,重新登录
      if (res.status === 401) {
        console.log(401);
      }
      return Promise.reject(res || "error");
    } else {
      return Promise.resolve(res);
    }
  },
  error => {
    console.log("err" + error); // for debug
    return Promise.reject(error);
  }
);

/**
 * HttpPost请求
 * @param {String} url 请求地址
 * @param {Object?} params 请求参数
 * @param {Object?} option 请求方法配置
 */
const POST = (url, params = {}, option = {}) => {
  return service({ ...option, url, method: "post", data: params });
};
/**
 * HttpGet请求
 * @param {String} url 请求地址
 * @param {Object?} params 请求参数
 * @param {Object?} option 请求方法配置
 */
const GET = (url, params = {}, option = { showloading: true }) => {
  url = process.env.VUE_APP_API + url;
  return service({ ...option, url, method: "get", params });
};

const CUSTOM_GET = (url, params = {}, option = { showloading: true }) => {
  return service({ ...option, url, method: "get", params });
};

export { service, POST, GET, CUSTOM_GET };



// WEBPACK FOOTER //
// src/util/request.js